import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { Color, Size } from 'const'
import Spinner from './spinner'

const Loading = ({ text, display, overlayOnClick }) => (
  <Wrapper display={display ? 1 : 0}>
    <Overlay onClick={overlayOnClick}></Overlay>
    <Content>
      {text && <Text>{text}</Text>}
      <Spinner />
    </Content>
  </Wrapper>
)

const getDisplay = (props) => {
  let display = 'none'

  if (props.display || props.display === 1) {
    display = 'inline'
  }

  return display
}

const Wrapper = styled.div`
  ${(props) => css`
    display: ${getDisplay(props)};
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
  `}
`
const Overlay = styled.div`
  background: ${Color.BACKGROUND.POPUP_GRAY};
  position: absolute;
  height: 100vh;
  width: 100%;
`
const Content = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 239px;
  max-width: 354px;
  transform: translate(-50%, -50%);
  padding: 22px 28px 30px 28px;
  text-align: center;
  border-radius: 8px;
`
const Text = styled.div`
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.REGULAR};
  padding: 11px 14px 0px 14px;
`

Loading.propTypes = {
  text: PropTypes.string,
  display: PropTypes.bool,
  overlayOnClick: PropTypes.func,
}

export default Loading
